import React from 'react';

interface Props
{
  type: string,
}
export const Icon: React.FC<Props> = ({type, children}) => <i className={`icon icon-${type}`}>{children}</i>;

export default Icon;